import { render } from "./OrderPurchaseDetail.vue?vue&type=template&id=259f0f06&scoped=true"
import script from "./OrderPurchaseDetail.vue?vue&type=script&lang=js"
export * from "./OrderPurchaseDetail.vue?vue&type=script&lang=js"

import "./OrderPurchaseDetail.vue?vue&type=style&index=0&id=259f0f06&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259f0f06"]])

export default __exports__